import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import styled from "styled-components";

import InputField from "../../Common/InputField";
import FormGroup from "../../Common/FormGroup";
import SelectField from "../../Common/AutoComplete";
import { Body, Check, Column, Header, Wrapper } from "../../../../Css";
import PhoneInput from "../../Common/PhoneInput";
import { usStates } from "../../../Options";
import { useTranslation } from "react-i18next";

function ShippingInformationForm({ onPrevious, setInitialValue }) {
  const { getFieldProps, values, touched, setFieldValue, isSubmitting } = useFormikContext();
  const { t } = useTranslation();

  useEffect(() => {
    touched.fName = false;
    touched.lName = false;
    touched.address_line_1 = false;
    touched.admin_area_2 = false;
    touched.billing_postal_code = false;
    touched.admin_area_1 = false;
    touched.shipping_phone_number = false;
    touched.shipping_phone_code = false;
  }, []);

  useEffect(() => {
    if (values.infoChecked) {
      setFieldValue('fName', values.firstNameB);
      setFieldValue('lName', values.lastNameB);
      setFieldValue('address_line_1', values.streetAddB);
      setFieldValue('address_line_2', values.addressB);
      setFieldValue('admin_area_2', values.CityB);
      setFieldValue('billing_postal_code', values.zipCodeB);
      setFieldValue('admin_area_1', values.stateB);
      setFieldValue('shipping_phone_number', values.billing_phone_number);
      setFieldValue('shipping_phone_code', values.billing_phone_code);
    }
  }, [
    values.infoChecked,
    values.firstNameB,
    values.lastNameB,
    values.streetAddB,
    values.addressB,
    values.CityB,
    values.zipCodeB,
    values.stateB,
    values.billing_phone_number,
    values.billing_phone_code
  ]);

  const handleCheck = () => {
    if (!values.infoChecked) {
      setFieldValue('fName', values.firstNameB);
      setFieldValue('lName', values.lastNameB);
      setFieldValue('address_line_1', values.streetAddB);
      setFieldValue('address_line_2', values.addressB);
      setFieldValue('admin_area_2', values.CityB);
      setFieldValue('billing_postal_code', values.zipCodeB);
      setFieldValue('admin_area_1', values.stateB);
      setFieldValue('shipping_phone_number', values.billing_phone_number);
      setFieldValue('shipping_phone_code', values.billing_phone_code);
      setFieldValue('infoChecked', true);
    } else {
      setFieldValue('fName', '');
      setFieldValue('lName', '');
      setFieldValue('address_line_1', '');
      setFieldValue('address_line_2', '');
      setFieldValue('admin_area_2', '');
      setFieldValue('billing_postal_code', '');
      setFieldValue('admin_area_1', '');
      setFieldValue('shipping_phone_number', '');
      setFieldValue('shipping_phone_code', '');
      setFieldValue('infoChecked', false);
    }
  };

  return (
    <div>
      <Wrapper>
        <Header>{`${t(
          "screens.upgradeMembership.shippingInformation"
        )}`}</Header>
        <Check>
          <input
            type="checkbox"
            onChange={handleCheck}
            checked={values.infoChecked}
          ></input>
          {`${t("screens.rightSidebar.text.sameAsShippingAddress")}`}
        </Check>
        <Body>
          <Column>
            <FormGroup
              label={`${t("screens.formData.firstName")}`}
              name="fName"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="fName"
                {...getFieldProps("fName")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.lastName")}`}
              name="lName"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="lName"
                {...getFieldProps("lName")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.streetAddress")}`}
              name="address_line_1"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="address_line_1"
                {...getFieldProps("address_line_1")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.address2")}`}
              name="address_line_2"
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="address_line_2"
                {...getFieldProps("address_line_2")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.city")}`}
              name="admin_area_2"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="text"
                name="admin_area_2"
                {...getFieldProps("admin_area_2")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.stateProvinceRegion")}`}
              name="admin_area_1"
              labelClassName="margin-top"
            >
              <SelectField
                {...getFieldProps("admin_area_1")}
                name="admin_area_1"
                options={usStates}
                placeholder="Select State"
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.zipCode")}`}
              name="billing_postal_code"
              requiredField
              labelClassName="margin-top"
            >
              <InputField
                type="number"
                name="billing_postal_code"
                {...getFieldProps("billing_postal_code")}
              />
            </FormGroup>
          </Column>
          <Column>
            <FormGroup
              label={`${t("screens.formData.phoneNumber")}`}
              name="shipping_phone_number"
              requiredField
              labelClassName="margin-top"
            >
              <Country>
                <PhoneInput
                  dialCodeName="phone_code"
                  name="shipping_phone_number"
                  onChange={(value, country) => {
                    setFieldValue("shipping_phone_code", country?.dialCode);
                  }}
                  value={values?.shipping_phone_number}
                />
              </Country>
            </FormGroup>
          </Column>
        </Body>
        <div className="shipping-btn">
          <button onClick={onPrevious} className="btn btn-primary">
            {`${t("screens.upgradeMembership.back")}`}
          </button>
          <button className="btn btn-primary" type="next" disabled={isSubmitting}>
            {isSubmitting ? (
                <Loader />
              ) : (
                t("screens.upgradeMembership.next")
              )}
          </button>
        </div>
      </Wrapper>
    </div>
  );
}

export default ShippingInformationForm;

const Country = styled.div`
  .react-tel-input .form-control {
    border-radius: 5px;
    border: 1px solid gray;
    height: 41px !important;
    width: 100%;
    background: white !important;
  }

  .react-tel-input .flag-dropdown {
    top: 0;
    bottom: 0;
    padding: 0;
    background-color: transparent !important;
    border: transparent !important;
    border-radius: 3px 0 0 3px;
  }

  input:-internal-autofill-selected {
    background-image: none !important;
    background: rgba(255, 255, 255, 0.2) !important;
    color: fieldtext !important;
  }
`;
const Loader = styled.div`
  justify-self: center;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 12px;
  height: 12px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;

  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;